<ngx-loading-bar></ngx-loading-bar>
<router-outlet></router-outlet>
<app-tap-to-top></app-tap-to-top>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<!-- <app-layout-box></app-layout-box> -->

